// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RunListItem } from './run-list-item';
import {
    RunListItemFromJSON,
    RunListItemFromJSONTyped,
    RunListItemToJSON,
    RunListItemToJSONTyped,
} from './run-list-item';

/**
 * 
 * @export
 * @interface ListRunsResponseContent
 */
export interface ListRunsResponseContent {
    /**
     * 
     * @type {string}
     * @memberof ListRunsResponseContent
     */
    nextToken?: string;
    /**
     * 
     * @type {Array<RunListItem>}
     * @memberof ListRunsResponseContent
     */
    runs: Array<RunListItem>;
}

/**
 * Check if a given object implements the ListRunsResponseContent interface.
 */
export function instanceOfListRunsResponseContent(value: object): value is ListRunsResponseContent {
    if (!('runs' in value) || value['runs'] === undefined) return false;
    return true;
}

export function ListRunsResponseContentFromJSON(json: any): ListRunsResponseContent {
    return ListRunsResponseContentFromJSONTyped(json, false);
}

export function ListRunsResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListRunsResponseContent {
    if (json == null) {
        return json;
    }
    return {
        
        'nextToken': json['nextToken'] == null ? undefined : json['nextToken'],
        'runs': ((json['runs'] as Array<any>).map(RunListItemFromJSON)),
    };
}

export function ListRunsResponseContentToJSON(json: any): ListRunsResponseContent {
    return ListRunsResponseContentToJSONTyped(json, false);
}

export function ListRunsResponseContentToJSONTyped(value?: ListRunsResponseContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nextToken': value['nextToken'],
        'runs': ((value['runs'] as Array<any>).map(RunListItemToJSON)),
    };
}
